/* eslint-disable lingui/no-unlocalized-strings -- valores do fio */
import { msg } from '@lingui/core/macro';
import { z } from 'zod';

import { defineFilters } from '@/shared/filters/define-filters';
import { listSearchSchema } from '@/shared/patterns/list-search';

import { bankAccountPath } from './bank-account.search';

// Caminhos, busca e filtro do Pix Automático (U6). Leve: entra no arquivo da rota (A01). As rotas são irmãs do
// detalhe, fora da barra de abas (`router.tsx:520-563`).

/** `/pix/pix-automatico` e as filhas, na ordem do painel (`AutomaticPix.tsx:16-47`). */
export const automaticPixPath = (id: string) => `${bankAccountPath(id)}/pix/pix-automatico`;
export const automaticPixHistoryPath = (id: string) => `${automaticPixPath(id)}/historico`;
export const automaticPixPendingPath = (id: string) => `${automaticPixPath(id)}/pendentes`;
export const automaticPixActivePath = (id: string) => `${automaticPixPath(id)}/ativas`;
export const automaticPixScheduledPath = (id: string) => `${automaticPixPath(id)}/agendados`;
export const automaticPixPaidPath = (id: string) => `${automaticPixScheduledPath(id)}/realizados`;

/** "Filtrar por" Status do histórico (`AutomaticPixHistoryFilters.tsx:12-19`), na ordem. */
export const AUTOMATIC_PIX_STATUS_OPTIONS = [
  { value: 'Processing', label: msg`Processando Sistema` },
  { value: 'Confirmed', label: msg`Confirmado` },
  { value: 'Rejected', label: msg`Rejeitado` },
  { value: 'Canceled', label: msg`Cancelado` },
  { value: 'PendingPayer', label: msg`Pendente Pagador` },
  { value: 'PendingUser', label: msg`Pendente Usuário` },
] as const;

/**
 * O filtro do histórico. ⚠️ Chave própria na URL (`pxa_status`), só na rota do histórico: no legado o filtro ficava no
 * `filterValuesContext` (último grupo, sem limpar) e o `status` dele trocava o status fixo de Pendentes, Ativas,
 * Agendados e Realizados (`bankAccountAutomaticPixContext.tsx:38-41`).
 */
export const automaticPixHistoryFilters = defineFilters([{ key: 'pxa_status', param: 'status', type: 'select', label: msg`Status`, options: AUTOMATIC_PIX_STATUS_OPTIONS }]);

/** O status fixo de cada lista (`AutomaticPixPendingContainer.tsx:37`, `AutomaticPixActivatedContainer.tsx:28`, `SC:31`, `PP:23`). */
export const AUTOMATIC_PIX_FIXED_STATUS = { pending: 'PendingPayer', active: 'Activated', scheduled: 'Scheduled', paid: 'Paid' } as const;

/** Página e tamanho na URL (5 por página, como o legado), e o filtro só no histórico. */
export const automaticPixListSearch = listSearchSchema({});
export const automaticPixHistorySearch = listSearchSchema({ ...automaticPixHistoryFilters.shape });
export type AutomaticPixListSearch = z.infer<typeof automaticPixListSearch>;
